module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/IPC.7dcd3f0d.png";